import React from 'react';
import { Box, Flex, Text, Image, Grid, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { ProductCard } from '../components/ProductCard';
import { mainCategories, categoryImages } from '../data/mockData';
import { Shirt, ArrowRight, Sparkles, TrendingUp } from 'lucide-react';
export const Home: React.FC = () => {
  const {
    products,
    adminSettings
  } = useAppContext();
  const navigate = useNavigate();
  const trendingProducts = products.filter(p => p.isTrending).slice(0, 4);
  const featuredProducts = products.slice(0, 6);
  return <Box className={adminSettings.animationsEnabled ? 'animate-fade-in' : ''} data-id="element-496">
      {/* Premium Hero Banner */}
      <Box className={adminSettings.animationsEnabled ? 'gradient-premium' : ''} bg={!adminSettings.animationsEnabled ? adminSettings.accentColor : undefined} px={6} py={10} color="white" textAlign="center" position="relative" overflow="hidden" data-id="element-497">
        <Box position="relative" zIndex={1} className={adminSettings.animationsEnabled ? 'animate-slide-up' : ''} data-id="element-498">
          <Flex justify="center" mb={3} data-id="element-499">
            <Box bg="whiteAlpha.200" px={3} py={1} borderRadius="full" data-id="element-500">
              <Text fontSize="xs" fontWeight="600" letterSpacing="0.1em" data-id="element-501">
                ✨ NEW COLLECTION
              </Text>
            </Box>
          </Flex>
          <Text fontSize="2xl" fontWeight="800" mb={2} letterSpacing="-0.02em" data-id="element-502">
            {adminSettings.bannerText}
          </Text>
          <Text fontSize="sm" mb={5} opacity={0.9} fontWeight="400" data-id="element-503">
            {adminSettings.bannerSubtext}
          </Text>
          <Button bg="white" color={adminSettings.accentColor} size="md" borderRadius="full" px={8} fontWeight="700" _hover={{
          transform: 'translateY(-2px)',
          shadow: 'xl'
        }} transition="all 0.3s ease" onClick={() => navigate('/products')} rightIcon={<ArrowRight size={16} data-id="element-505" />} data-id="element-504">
            Shop Now
          </Button>
        </Box>
        {/* Decorative elements */}
        <Box position="absolute" top="-40px" right="-40px" w="150px" h="150px" bg="whiteAlpha.100" borderRadius="full" data-id="element-506" />
        <Box position="absolute" bottom="-50px" left="-30px" w="120px" h="120px" bg="whiteAlpha.100" borderRadius="full" data-id="element-507" />
      </Box>

      {/* Category Cards - Men, Women, Kids */}
      <Box px={4} py={6} bg="white" data-id="element-508">
        <Flex align="center" gap={2} mb={5} data-id="element-509">
          <Sparkles size={18} color="var(--chakra-colors-gold-500)" data-id="element-510" />
          <Text fontSize="lg" fontWeight="700" color="gray.800" letterSpacing="-0.01em" data-id="element-511">
            Shop by Category
          </Text>
        </Flex>
        <Grid templateColumns="repeat(3, 1fr)" gap={3} data-id="element-512">
          {mainCategories.map((cat, idx) => <Box key={cat} position="relative" borderRadius="16px" overflow="hidden" cursor="pointer" className={adminSettings.animationsEnabled ? 'hover-zoom' : ''} onClick={() => navigate(`/products/${cat}`)} style={adminSettings.animationsEnabled ? {
          animationDelay: `${idx * 0.15}s`
        } : {}} h="180px" data-id="element-513">
              <Image src={categoryImages[cat]} alt={cat} w="full" h="full" objectFit="cover" data-id="element-514" />
              <Box position="absolute" bottom={0} left={0} right={0} bgGradient="linear(to-t, blackAlpha.800, transparent)" p={3} pt={10} data-id="element-515">
                <Text color="white" fontWeight="700" fontSize="md" letterSpacing="0.02em" data-id="element-516">
                  {cat}
                </Text>
                <Flex align="center" gap={1} mt={0.5} data-id="element-517">
                  <Text color="whiteAlpha.800" fontSize="10px" fontWeight="500" data-id="element-518">
                    Explore
                  </Text>
                  <ArrowRight size={10} color="white" data-id="element-519" />
                </Flex>
              </Box>
            </Box>)}
        </Grid>
      </Box>

      {/* Products Section */}
      {products.length === 0 ? <Flex direction="column" align="center" justify="center" py={16} px={6} textAlign="center" bg="gray.50" className={adminSettings.animationsEnabled ? 'animate-slide-up' : ''} data-id="element-520">
          <Box className={adminSettings.animationsEnabled ? 'animate-float' : ''} mb={5} data-id="element-521">
            <Box bg="brand.50" p={6} borderRadius="full" data-id="element-522">
              <Shirt size={56} color={adminSettings.accentColor} data-id="element-523" />
            </Box>
          </Box>
          <Text fontSize="xl" fontWeight="700" color="gray.800" mb={2} data-id="element-524">
            Products Coming Soon 👕
          </Text>
          <Text color="gray.500" fontSize="sm" maxW="280px" lineHeight="1.6" data-id="element-525">
            Sky Brand is preparing something stylish for you. Stay tuned!
          </Text>
        </Flex> : <>
          {trendingProducts.length > 0 && <Box px={4} py={6} bg="gray.50" className={adminSettings.animationsEnabled ? 'animate-slide-up' : ''} data-id="element-526">
              <Flex justify="space-between" align="center" mb={4} data-id="element-527">
                <Flex align="center" gap={2} data-id="element-528">
                  <TrendingUp size={18} color="var(--chakra-colors-red-500)" data-id="element-529" />
                  <Text fontSize="lg" fontWeight="700" color="gray.800" data-id="element-530">
                    Trending Now
                  </Text>
                </Flex>
                <Button variant="ghost" size="sm" color={adminSettings.accentColor} fontWeight="600" onClick={() => navigate('/products')} rightIcon={<ArrowRight size={14} data-id="element-532" />} data-id="element-531">
                  View All
                </Button>
              </Flex>
              <Grid templateColumns="repeat(2, 1fr)" gap={3} data-id="element-533">
                {trendingProducts.map((product, idx) => <ProductCard key={product.id} product={product} index={idx} data-id="element-534" />)}
              </Grid>
            </Box>}

          {featuredProducts.length > 0 && <Box px={4} py={6} bg="white" className={adminSettings.animationsEnabled ? 'animate-slide-up' : ''} data-id="element-535">
              <Flex align="center" gap={2} mb={4} data-id="element-536">
                <Sparkles size={18} color="var(--chakra-colors-gold-500)" data-id="element-537" />
                <Text fontSize="lg" fontWeight="700" color="gray.800" data-id="element-538">
                  Featured Products
                </Text>
              </Flex>
              <Grid templateColumns="repeat(2, 1fr)" gap={3} data-id="element-539">
                {featuredProducts.map((product, idx) => <ProductCard key={product.id} product={product} index={idx} data-id="element-540" />)}
              </Grid>
            </Box>}
        </>}
    </Box>;
};